import axios from 'axios'

import { BASE_URL_MEET } from './env'

export const meetAxiosInstance = axios.create({
  baseURL: BASE_URL_MEET,
})
